import { PatientPaymentControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * Archive (or unarchive) a patient card.
 * Per ECRH-3027: cards are not deleted/deactivated, only archived.
 *
 * @author Rajkumar Rathod
 */
export const useArchivePatientCard = () =>
  useMutationWithLoading(
    async (params: {
      patientCardId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientPaymentControllerApi(
        getConfigObject()
      ).updatePatientCardArchiveStatus(
        params?.patientCardId,
        params?.status,
        params?.xTENANTID
      )
  );
